'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styleJs = require('./style.js');

var _styleJs2 = _interopRequireDefault(_styleJs);

var _printStylesJs = require('../print-styles.js');

var _printStylesJs2 = _interopRequireDefault(_printStylesJs);

var PrintStyle = _react2['default'].createClass({
  displayName: 'PrintStyle',

  getInitialState: function getInitialState() {
    return this._getStylesState();
  },

  componentDidMount: function componentDidMount() {
    this.subscription = _printStylesJs2['default'].subscribe(this._onChange);
  },

  componentWillUnmount: function componentWillUnmount() {
    this.subscription.remove();
  },

  _onChange: function _onChange() {
    this.setState(this._getStylesState());
  },

  _getStylesState: function _getStylesState() {
    return {
      styles: _printStylesJs2['default'].getPrintStyles()
    };
  },

  render: function render() {
    return _react2['default'].createElement(_styleJs2['default'], { rules: {
        mediaQueries: {
          print: this.state.styles
        }
      } });
  }
});

exports['default'] = PrintStyle;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/radium/lib/components/print-style-sheet.js
 ** module id = 192
 ** module chunks = 1
 **/